<template>
  <div
    class="file-message-montainer"
    :title="TUITranslateService.t('TUIChat.单击下载')"
    @click="download(props.content.url)"
  >
   <!-- <Icon
      :file="files"
      class="file-icon"
    /> -->
	<img class="fileimg" v-if="props.content.name.indexOf('pdf') > -1" src="@/assets/img/file/icon-1.png" />
	<img class="fileimg" v-else-if="props.content.name.indexOf('zip') > -1" src="@/assets/img/file/zip.png" />
	<img class="fileimg" v-else-if="props.content.name.indexOf('doc') > -1" src="@/assets/img/file/icon-2.png" />
	<img class="fileimg" v-else-if="props.content.name.indexOf('xls') > -1" src="@/assets/img/file/xlsx.png" />
	<img class="fileimg" v-else src="@/assets/img/file/icon-5.png" />
    <div>
      <div>{{ props.content.name }}</div>
      <div>{{ props.content.size }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { withDefaults } from '../../../../adapter-vue';
import { TUITranslateService, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../common/Icon.vue';
import files from '../../../../assets/icon/file-light.svg';
import type { IFileMessageContent } from '../../../../interface';

const props = withDefaults(
  defineProps<{
    content: IFileMessageContent;
    messageItem: IMessageModel;
  }>(),
  {
    content: () => ({} as IFileMessageContent),
    messageItem: () => ({} as IMessageModel),
  },
);

const download = (url) => {
  if (props.messageItem.hasRiskContent) {
    return;
  }
  window.open(url)
  // const option = {
  //   mode: 'cors',
  //   headers: new Headers({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   }),
  // } as RequestInit;
  // // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
  // if ((window as any)?.fetch) {
  //   fetch(props.content.url, option)
  //     .then(res => res.blob())
  //     .then((blob) => {
  //       const a = document.createElement('a');
  //       const url = window.URL.createObjectURL(blob);
  //       a.href = url;
  //       a.download = props.content.name;
  //       a.click();
  //     });
  // } else {
  //   const a = document.createElement('a');
  //   a.href = props.content.url;
  //   a.target = '_blank';
  //   a.download = props.content.name;
  //   a.click();
  // }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/styles/common";

.file-message-montainer {
  display: flex;
  flex-direction: row;
  cursor: pointer;

  .file-icon {
    margin: auto 8px;
  }
  .fileimg{
	  display: block;
	   margin: auto 8px;
	   width: 22px;
  }
}
</style>
